import * as React from "react";
import { NeurapulseTestCompletionStatusType } from "src/common/Enums";
import NeurapulseIcon, { getNeurapulseTitle } from "src/components/common/NeurapulseIcon";

interface Props {
  neurapulseStatusId: NeurapulseTestCompletionStatusType | undefined;
}

export const NeurapulseResultCell: React.FC<Props> = ({ neurapulseStatusId }) => {
  if (neurapulseStatusId !== undefined) {
    const npText = getNeurapulseTitle(neurapulseStatusId);
    return (
      <span title={npText} style={{ display: "flex", alignItems: "center" }}>
        <NeurapulseIcon status={neurapulseStatusId} size={24} /> {npText}
      </span>
    );
  }
  return <>-</>;
};
